
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/AboutUs",
      function () {
        return require("private-next-pages/article/AboutUs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/AboutUs"])
      });
    }
  